/**
 * Las piezas que comparten los dos hilos de comentarios del panel: el de
 * «Notas del equipo» (widget de Inicio) y el de la ficha de un contacto.
 *
 * Vivían dentro de `OverviewSection` cuando el hilo era uno solo. Al aparecer
 * el segundo, copiarlas habría dejado dos relojes y dos avatares que se separan
 * en cuanto alguien toca uno.
 */
import { activeLanguage } from './i18n'
import { formatters } from '@webbuilder/i18n'
import { ProfileAvatarContent } from '@webbuilder/ui'

/**
 * «hace 21 horas» / «21 hours ago».
 *
 * Delega en el formateador de `@webbuilder/i18n`: una copia propia acababa
 * diciendo la hora en otro idioma que el resto del panel.
 */
export function relativeNoteTime(iso: string | null | undefined): string {
  return formatters(activeLanguage()).relative(iso) ?? ''
}

/** La foto de quien dejó el comentario, o su inicial. */
export function NoteAvatar({ name, url }: { name: string; url?: string | null | undefined }) {
  return (
    <span className="dash-note-avatar" aria-hidden="true">
      <ProfileAvatarContent name={name || '?'} src={url} />
    </span>
  )
}

/**
 * La tecla que se nombra en las ayudas, según el teclado de quien mira.
 *
 * El manejador acepta las dos desde siempre; lo que estaba mal era el rótulo,
 * que prometía ⌘ a todo el mundo — en Windows y Linux se lee como una función
 * que no existe.
 */
export const COMMAND_KEY = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent)
  ? '⌘'
  : 'Ctrl'
